import React from 'react'

const CustomVideo = ({ src, className, controls = true, style = {} }: any) => {
    if (!src) return null
    return (
        <video
            style={style}
            src={src}
            className={className || "ifv-slide__img"}
            controls={controls}
            playsInline
            preload="metadata"
            controlsList="nodownload noplaybackrate noremoteplayback"
            disablePictureInPicture
            onContextMenu={(e) => e.preventDefault()}
        />
    )
}

export default CustomVideo